import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Color, Icons } from '@lsq-frontend/common-ui';

@Component({
    selector: 'admin-buyer-configuration-infor-nexus-enabled',
    template: `
        <buyer-configuration-section
            [hasClickedSave]="hasClickedSave"
            sectionTitle="Infor Nexus Integration"
            sectionFormControlName="inforNexusEnabled"
            [sectionFormGroup]="inforNexusEnabledFormGroup"
        >
            <form [formGroup]="inforNexusEnabledFormGroup" [style.padding]="'2rem 3rem'">
                <p class="font-weight-400 text-black" [style.marginBottom]="'1rem'">
                    Allows LSQ to ingest invoices and send financing decisions for this buyer
                    through InforNexus, a supply chain platform utilized for select international
                    buyer and supplier relationships.
                </p>
            </form>
        </buyer-configuration-section>
    `
})
export class AdminBuyerConfigurationInforNexusEnabledComponent {
    @Input() public hasClickedSave: boolean;
    @Input() public inforNexusEnabledFormGroup: FormGroup;
    public readonly icons = Icons;
    public readonly color = Color;
}
